import Vue      from 'vue';
import Vuex 		from 'vuex';

Vue.use(Vuex)

export const TYPES_CHAMPS = [
  'TEXTE',
  'CHOIX_MULTIPLE',
  'CASES_COCHER'
];

export default new Vuex.Store({
  state: {
    title: "",
  },
  getters: {
    
	},
  mutations: {
    setTitle (state, title) {
      document.title = title + " - RRGMRP";
      state.title = title;
    },
  },
  actions: {
    updateNbNonTraitees ({ state, commit }) {
      return new Promise((resolve, reject) => {
        resolve();
      })
    }
  }
})


// WEBPACK FOOTER //
// ./src/store.js